export default __webpack_public_path__ + "static/media/bg_image4.9e951bf6.jpg";